import { Card } from '@/components/ui/card';

const MileageSettings = () => {
  return (
    <div className="h-screen flex flex-col overflow-hidden" style={{ backgroundColor: '#f5f5f5' }}>
      {/* Header */}
      <div className="flex-none w-full" style={{ backgroundColor: '#e8e8e8', borderBottom: '2px solid #ee7203' }}>
        <div className="max-w-md mx-auto px-4 py-3">
          <h1 className="text-xl font-bold text-gray-800">Mileage Settings</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 w-full px-3 py-4 overflow-y-auto" style={{ paddingBottom: '140px' }}>
        <div className="max-w-md mx-auto space-y-4">
          
          {/* Vehicle Settings Card */}
          <Card className="p-4 rounded-2xl" style={{ backgroundColor: '#e8e8e8', border: '2px solid #ee7203' }}>
            <h2 className="text-lg font-bold text-gray-800 mb-3">Vehicle Information</h2>
            <div className="space-y-3">
              <div>
                <label className="text-sm text-gray-700 font-medium">Vehicle Registration</label>
                <input
                  type="text"
                  defaultValue="VX24 ZBW"
                  className="w-full mt-1 px-3 py-2 rounded-lg border-2 border-gray-300 focus:border-[#ee7203] focus:outline-none"
                />
              </div>
              <div>
                <label className="text-sm text-gray-700 font-medium">Fuel Card PIN</label>
                <input
                  type="password"
                  defaultValue="1234"
                  className="w-full mt-1 px-3 py-2 rounded-lg border-2 border-gray-300 focus:border-[#ee7203] focus:outline-none"
                />
              </div>
            </div>
          </Card>

          {/* Mileage Settings Card */}
          <Card className="p-4 rounded-2xl" style={{ backgroundColor: '#e8e8e8', border: '2px solid #ee7203' }}>
            <h2 className="text-lg font-bold text-gray-800 mb-3">Mileage Preferences</h2>
            <div className="space-y-3">
              <div>
                <label className="text-sm text-gray-700 font-medium">Default Mileage Rate (per mile)</label>
                <input
                  type="number"
                  defaultValue="0.45"
                  step="0.01"
                  className="w-full mt-1 px-3 py-2 rounded-lg border-2 border-gray-300 focus:border-[#ee7203] focus:outline-none"
                />
              </div>
            </div>
          </Card>

          {/* Save Button */}
          <button
            className="w-full py-3 rounded-xl font-bold text-white transition-all hover:scale-105"
            style={{ backgroundColor: '#ee7203' }}
          >
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default MileageSettings;
